import React from 'react';
import _ from 'lodash';

import { FormattedMessage, useIntl } from 'react-intl';
import { useLocale } from 'src/modules/locale';
import { Row, Col } from 'antd';
import { rowReferenceGridProps } from 'src/utils/grid';
import { ArticlesDetailsContent } from 'src/modules/articles';
import styles from './ProfessionalsReferencesDetailsPage.module.scss';
import { ArticleEntity } from 'src/modules/articles';
import { ReferenceEntity } from 'src/modules/professionals';

interface ProfessionalsReferencesDetailsPageProps {
  referencesPage: {
    article: ArticleEntity;
    relatedReferences: ReferenceEntity[];
  };
}

const ProfessionalsReferencesDetailsPage: React.FunctionComponent<ProfessionalsReferencesDetailsPageProps> = (
  props
) => {
  const { getLocalizedObject } = useLocale();
  const intl = useIntl();

  if (!props?.referencesPage) return null;

  const { article, relatedReferences } = getLocalizedObject(props.referencesPage);
  const { reference } = article || {};

  const {
    architect_name,
    interior_designer_name,
    location_types,
    country,
    city,
    space_size,
    duration,
    assets,
    products,
    reference_category,
  } = reference || {};

  const assetsLocation =
    assets && assets.find((asset: any) => asset.creator || asset.country || asset.city);

  const breadcrumbs = [
    {
      title: intl.formatMessage({ id: 'breadcrumbs/professionals' }),
      href: '/professionals',
      as: '/professionals',
    },
    {
      title: intl.formatMessage({ id: 'breadcrumbs/professionals/projects' }),
      href: '/professionals/projects',
      as: '/professionals/projects',
    },
    {
      title: article?.hero?.title,
      as: `/professionals/projects/${encodeURIComponent(article?.slug)}`,
      href: '/professionals/projects/[slug]',
    },
  ];

  return (
    <ArticlesDetailsContent
      article={article}
      breadcrumbs={breadcrumbs}
      products={products}
      // relatedArticlesHeadingTitle={intl.formatMessage({
      //   id: 'page/professionals/projects/details/related_projects',
      // })}
      relatedArticles={relatedReferences.map((ref: any) => ({
        ...ref.article,
        article_category: reference_category,
      }))}>
      <div className={styles.container}>
        <Row {...rowReferenceGridProps}>
          {country && city && (
            <Col xs={24} sm={8}>
              <div className={styles.projectProperty}>
                <FormattedMessage id="page/professionals/projects/details/location" />
              </div>
              <div className={styles.projectValue}>
                {city.name}, {country.name}
              </div>
            </Col>
          )}
          {!!location_types && !!location_types.length && (
            <Col xs={24} sm={8}>
              <div className={styles.projectProperty}>
                <FormattedMessage id="page/professionals/projects/details/room" />
              </div>
              <div className={styles.projectValue}>
                {location_types
                  .reduce(
                    (acc: any, locationType: any) =>
                      acc.concat(` ${_.capitalize(locationType.name)},`),
                    ''
                  )
                  .slice(0, -1)}
              </div>
            </Col>
          )}
          {!!architect_name && (
            <Col xs={24} sm={8}>
              <div className={styles.projectProperty}>
                <FormattedMessage id="page/professionals/projects/details/architect" />
              </div>
              <div className={styles.projectValue}>{architect_name}</div>
            </Col>
          )}
          {!!interior_designer_name && (
            <Col xs={24} sm={8}>
              <div className={styles.projectProperty}>
                <FormattedMessage id="page/professionals/projects/details/interior_designer" />
              </div>
              <div className={styles.projectValue}>{interior_designer_name}</div>
            </Col>
          )}
          {!!duration && (
            <Col xs={24} sm={8}>
              <div className={styles.projectProperty}>
                <FormattedMessage id="page/professionals/projects/details/project_duraction" />
              </div>
              <div className={styles.projectValue}>
                {Math.round(duration)}&nbsp;
                <FormattedMessage
                  id="page/professionals/projects/details/years"
                  values={{
                    duration,
                  }}
                />
              </div>
            </Col>
          )}
          {!!space_size && (
            <Col xs={24} sm={8}>
              <div className={styles.projectProperty}>
                <FormattedMessage id="page/professionals/projects/details/space_size" />
              </div>
              <div className={styles.projectValue}>{space_size}</div>
            </Col>
          )}
          {!!assetsLocation && (
            <Col xs={24} sm={8}>
              <div className={styles.projectProperty}>
                <FormattedMessage id="page/professionals/projects/details/pictures" />
              </div>
              <div className={styles.projectValue}>
                {assetsLocation.creator}
                {/* , {assetsLocation.city.name}, {assetsLocation.country.name} */}
              </div>
            </Col>
          )}
        </Row>
      </div>
    </ArticlesDetailsContent>
  );
};

export default ProfessionalsReferencesDetailsPage;
